import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { GET_ACTIVE_SYS_TYPE } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import DeqPieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";

const ActiveSysTypeChart = () => {
  const { loading, data, error } = useQuery(GET_ACTIVE_SYS_TYPE);
  const colors = ["#0080b7", "#00afd8", "#add361"];
  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Active Water System Counts</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row>
        <Col>
          <h3>Active Water System Counts</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeWaterSystemCountsLegend'>
          <ChartLegend data={data.getSystemByTypeStats} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeWaterSystemCountsChart'>
          <DeqPieChart data={data.getSystemByTypeStats} colorArray={colors} />
        </Col>
      </Row>
    </>
  );
};
export default ActiveSysTypeChart;
